import Vue from 'vue'
import { ValidationProvider, extend, ValidationObserver, localize } from 'vee-validate'
import id from 'vee-validate/dist/locale/id.json'
import * as rules from 'vee-validate/dist/rules'

Object.keys(rules).forEach(
  rule => { 
    extend(rule, rules[rule]) 
  }
)

extend('greater_than_start', {
  params: ['start'], // Declare start as a parameter
  validate(value, { start }) {
    const startTime = new Date(`1970-01-01T${start}:00`)
    const endTime = new Date(`1970-01-01T${value}:00`)

    return endTime > startTime
  },
  message: 'Jam Selesai harus lebih besar dari Jam Mulai',
})

extend('not99999', {
  validate: value => value != 99999,
  message: 'Frekuensi Lainnya Tidak Diperbolehkan'
})

// validasi mutual-exclusive: tidak boleh Debet & Kredit terisi bersamaan pada baris yang sama
extend('either_or', {
  params: ['other'], // nilai sisi lawan (jika ini Debet, other = nilai Kredit)
  validate(value, { other }) {
    return !(Number(value) > 0 && Number(other) > 0)
  },
  message: 'Hanya salah satu (Debet atau Kredit) yang boleh diisi'
})

localize('id', id)


Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)